import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    paper: {
      boxShadow: '-1px 3px 25px 3px rgb(172 167 184 / 46%)',
    },
  })
);
